<footer class="page-footer">

  <div class="container"
       fxLayout="row wrap"
       fxLayoutAlign="space-between center">
    <div class="page-footer__copyrights">
      <p>{{ 'FOOTER.ALL_PAGES.COPYRIGHT.LABEL' | translate }}</p>
    </div>
  </div>

</footer>
